import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import themeService from '../themes/themeService';

const { logo } = themeService;
const { palette } = themeService.getTheme();
const styles = {
    dashboard: {
        backgroundColor: palette.background.dashboard,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column'
    },
    dashboardContainer: {
        display: 'flex',
        height: '100vh',
        flexDirection: 'row',
        flexWrap: 'wrap',
        paddingTop: '50px',
        justifyContent: 'space-around'
    },
    dashboardContainerDiv: {
        padding: '0 10px'
    },
    dashboardContainerLink: {
        border: 'solid 3px',
        fontFamily: 'sans-serif',
        fontSize: '2rem',
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center',
        wordSpacing: '250px',
        color: palette.dashboard.containerLinks.text,
        backgroundColor: palette.dashboard.containerLinks.background,
        borderColor: palette.dashboard.containerLinks.border,
        width: '250px',
        height: '250px',
        outlineStyle: 'none',
        outlineWidth: '0',
        '&:focus': {
            boxShadow: `0 0 1.5rem ${palette.dashboard.containerLinks.border}`
        },
        '&:hover': {
            boxShadow: `0 0 1.5rem ${palette.dashboard.containerLinks.border}`
        }
    }
}

function Dashboard({classes}) {
    return (<div className={classes.dashboard}>
        <div className="logo-container">
            <div>
                <img style={logo.style} src={logo.imageSource} alt={logo.altText} />
            </div>
        </div>
        <div className={classes.dashboardContainer}>
            <div className={classes.dashboardContainerDiv}>
                <Link className={classes.dashboardContainerLink} to='/customerSearch'>Search Customers</Link>
            </div>
            <div className={classes.dashboardContainerDiv}>
                <Link className={classes.dashboardContainerLink} to='/search/invoices'>Search Invoices</Link>
            </div>
            <div className={classes.dashboardContainerDiv}>
                <Link className={classes.dashboardContainerLink} to='/createCustomer'>Create Customer</Link>
            </div>
        </div>
    </div>);
}
export default withStyles(styles)(Dashboard);